module.exports = __webpack_public_path__ + "img/banner.caa6e051.jpg";